export enum NewHomeAvailableFromTypes {
  ExactDate = 'Exact date',
  Asap = 'ASAP',
  ThirtyDaysBeforeSow = '30 days before SOW',
  TwoWeeksNotice = '2 weeks notice',
}
